const tabFocusStyles = {
    '--tab-outline-color': '#656BFC',
    '&.tab-disabled': {
        '& *[tabindex]:focus': {
            outline: 'none',
        },
    },
    '&.tab-enabled': {
        '& *[tabindex]:focus': {
            outlineWidth: 2,
            outlineStyle: 'auto',
            outlineOffset: -1,
            outlineColor: 'var(--tab-outline-color)',
        },
    },
};
function withTabFocus() {
    function tabbed(e) {
        if (e.code === 'Tab') {
            document.documentElement.classList.remove('tab-disabled');
            document.documentElement.classList.add('tab-enabled');
            window.removeEventListener('keydown', tabbed);
            window.addEventListener('mousedown', clicked);
        }
    }
    function clicked() {
        document.documentElement.classList.remove('tab-enabled');
        document.documentElement.classList.add('tab-disabled');
        document.getElementById('tab-styles')?.remove();
        window.removeEventListener('mousedown', clicked);
        window.addEventListener('keydown', tabbed);
    }
    document.documentElement.classList.add('tab-disabled');
    window.addEventListener('keydown', tabbed);
}
const canTab = () => 'html[class*="tab-enabled"] &';

export { canTab, tabFocusStyles, withTabFocus };
